import React, { useEffect, createElement } from 'react';
export const GoogleTag = () => {
  useEffect(() => {
    // Create first script element (async script) - AW-649210165
    const scriptAsync1 = document.createElement('script');
    scriptAsync1.async = true;
    scriptAsync1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-649210165';
    document.head.appendChild(scriptAsync1);
    // Create second script element (inline script) - AW-649210165
    const scriptInline1 = document.createElement('script');
    scriptInline1.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-649210165');
    `;
    document.head.appendChild(scriptInline1);
    // Create third script element (async script) - G-LTTKB8L6K8
    const scriptAsync2 = document.createElement('script');
    scriptAsync2.async = true;
    scriptAsync2.src = 'https://www.googletagmanager.com/gtag/js?id=G-LTTKB8L6K8';
    document.head.appendChild(scriptAsync2);
    // Create fourth script element (inline script) - G-LTTKB8L6K8
    const scriptInline2 = document.createElement('script');
    scriptInline2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-LTTKB8L6K8');
    `;
    document.head.appendChild(scriptInline2);
    // Cleanup function
    return () => {
      document.head.removeChild(scriptAsync1);
      document.head.removeChild(scriptInline1);
      document.head.removeChild(scriptAsync2);
      document.head.removeChild(scriptInline2);
    };
  }, []); // Empty dependency array means this effect runs once on mount
  return null; // This component doesn't render anything
};